  <ng-container *ngIf="editable">
    <mat-form-field
      *ngIf="searchInput.controls.address as input"
      class="custom-mat-form-field w-full custom-border-bottom custom-line-ripple d-block w-full px-1 mb-n-10 z-index-1">
      <input
        matInput
        type="text"
        data-testid="search-location"
        [placeholder]="labels.inputPlaceholder"
        [formControl]="input"
        (keyup.enter)="input.value && searchAction$.next()">

      <div
        class="fx-row"
        matSuffix>
        <button
          mat-icon-button
          data-testid="search-location-button"
          aria-label="Search"
          [class.hidden]="!input.value"
          (click)="searchAction$.next()">
          <mat-icon>search</mat-icon>
        </button>
        <button
          mat-icon-button
          aria-label="Clear"
          [class.hidden]="!input.value"
          (click)="input?.setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-form-field>
  </ng-container>

  <div
    #map
    class="h-60 mx-auto radius-4">
  </div>

<lib-item-message
  class="mt-1"
  [containerStyle]="'bg-grey-100'"
  [start]="{
    type: 'ionic-icon',
    icon: 'location',
    cssCustomClass: 'text-grey-400'
  }">
  <span
    data-testid="coordinates"
    class="body-3 text-grey-400">
    {{ _innerCoordinates }}
  </span>
</lib-item-message>
